import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    width: 17,
    height: 1,
    marginTop: 15.5,
    marginLeft: 1.5,
    marginBottom: 7,
    backgroundColor: PALETTE.primaryTextDisabled,
  },
  btnContainer: {
    width: '100%',
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  content: {
    display: 'flex',
    flexDirection: 'row'
  },
  touchableOpacityEnabled:{
    flex: 1,
    borderRadius:2,
    marginTop:5,
    height:40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: PALETTE.touchableOpacityEnable
  },
  touchableOpacityDisabled:{
    flex: 1,
    borderRadius:2,
    borderWidth: 1,
    height:40,
    marginTop:5,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor:PALETTE.primaryRadioButtonBorder,
    backgroundColor: PALETTE.touchableOpacityDisable
  },
  textEnabled:{
    color:PALETTE.primaryBackground, 
    fontSize: 16, 
    fontStyle: 'normal',
    // lineHeight: 24,
  },
  textDisabled:{
    color:PALETTE.primaryRadioButtonBorder, 
    fontSize:16
  },
  loadingSpinner:{
    marginLeft: 10,
    top: 0,
    bottom: 0,
    right: 0,
    margin: 'auto'
  }
});
